// components/media/ImageField.jsx
import { useState } from "react";
import { Button, Space } from "antd";
import { PictureOutlined, DeleteOutlined } from "@ant-design/icons";
import MediaPickerModal from "./MediaPickerModal";

export default function ImageField({ value, onChange }) {
  const [open, setOpen] = useState(false);

  return (
    <>
      {value ? (
        <div className="image-field">
          <img src={value} alt="" />
          <Space>
            <Button
              size="small"
              icon={<PictureOutlined />}
              onClick={() => setOpen(true)}
            >
              Солих
            </Button>
            <Button
              size="small"
              danger
              icon={<DeleteOutlined />}
              onClick={() => onChange?.(null)}
            />
          </Space>
        </div>
      ) : (
        <Button icon={<PictureOutlined />} onClick={() => setOpen(true)}>
          Зураг сонгох
        </Button>
      )}

      <MediaPickerModal
        open={open}
        onClose={() => setOpen(false)}
        onSelect={(url) => {
          onChange?.(url);
          setOpen(false);
        }}
      />
    </>
  );
}
